import React from "react";
import {
  ArrowDownIcon,
  CloseIcon,
  EmailSuccessIcon,
  InfoIcon,
  ProfileIcon,
  DeleteIcon,
  EditIcon,
  SignSuccess,
  WarnIcon,
  ArrowUp,
  Exclamation,
  UserIcon,
  Tick,
  AccountPending,
  SchoolIcon,
  HomeIcon,
  Loader,
  BackArrow,
} from "./icons";
import FailIcon from "./icons/fail-icon";

export const iconNames = {
  arrowDown: ArrowDownIcon,
  close: CloseIcon,
  emailSuccess: EmailSuccessIcon,
  info: InfoIcon,
  profile: ProfileIcon,
  delete: DeleteIcon,
  edit: EditIcon,
  signsuccess: SignSuccess,
  warn: WarnIcon,
  upArrow: ArrowUp,
  exclamation: Exclamation,
  user: UserIcon,
  tick: Tick,
  pending: AccountPending,
  school: SchoolIcon,
  home: HomeIcon,
  loader: Loader,
  failIcon: FailIcon,
  backArrow:BackArrow,
};

export type IconProps = {
  name: keyof typeof iconNames;
};
export default function Icon({ name }: IconProps) {
  const IconComponent = iconNames[name];
  return <IconComponent />;
}
